import React from 'react';

export default function Footer() {
    return (
        <footer className="contact-section" id="contact">
            <div className="contact-container">
                <div className="contact-info">
                    <div className="map-placeholder">
                        <div className="map-bg">
                            <iframe
                                title="map"
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3501.066493604386!2d77.3756!3d28.6577!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjjCsDM5JzI3LjciTiA3N8KwMjInMzIuMiJF!5e0!3m2!1sen!2sin!4v1620000000000!5m2!1sen!2sin"
                                width="100%"
                                height="100%"
                                style={{ border: 0 }}
                                allowFullScreen=""
                                loading="lazy">
                            </iframe>
                        </div>
                    </div>

                    <div className="contact-details">
                        <div className="contact-item">
                            <span className="icon">📞</span>
                            <span>9717 405 875</span>
                        </div>
                        <div className="contact-item">
                            <span className="icon">✉️</span>
                            <span>swaimsidhmarble@gmail.com</span>
                        </div>
                        <div className="contact-item">
                            <span className="icon">📍</span>
                            <span>5/27, 3rd Floor, 302, G.T. Road, Near Rajinder Nagar Police Chowk, Sahibabad, Ghaziabad, Uttar Pradesh - 201005</span>
                        </div>
                    </div>
                </div>

                <div className="contact-form-wrapper">
                    <h2>Connect Us</h2>
                    <form
                        className="contact-form"
                        action="https://formsubmit.co/swaimsidhmarble@gmail.com"
                        method="POST"
                    >
                        {/* FormSubmit Configuration */}
                        <input type="hidden" name="_subject" value="New Inquiry from Marble Website" />
                        <input type="hidden" name="_captcha" value="false" />
                        <input type="hidden" name="_template" value="table" />

                        <div className="form-group">
                            <label>Name</label>
                            <input type="text" name="name" required />
                        </div>
                        <div className="form-group">
                            <label>Email</label>
                            <input type="email" name="email" required />
                        </div>
                        <div className="form-group">
                            <label>Contact</label>
                            <input type="tel" name="phone" required />
                        </div>
                        <div className="form-group">
                            <label>Message</label>
                            <textarea name="message" rows="4" required></textarea>
                        </div>
                        <button type="submit" className="submit-btn">Call me</button>
                    </form>
                </div>
            </div>
        </footer>
    );
}
